import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { TypedMemo } from '../../../common/types';
import type { CampaignResultsPage } from '../outreachTypes';
import { WorkedGroup } from './WorkedGroup';
import { LEARNED_SENTENCES } from './resultsCopy';
import { resultsMessages as messages } from './resultsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import card from '../live/Campaign.module.scss';
import styles from './Results.module.scss';
/* eslint-enable css-modules/no-unused-class */

type WhatWorkedProps = Pick<CampaignResultsPage, 'byKind' | 'bySize' | 'byAngle' | 'learned' | 'songTitle'>;

/**
 * "What worked" (design outreach-v2 n1): replies by kind, adds by playlist size, replies by the
 * angle of the pitch. A group needs 30 pitches; with none, the column says "Too few pitches yet".
 * The line of what Plug learned is a fixed text for each `learned.sentenceKey`, never AI text.
 */
const WhatWorkedComponent: React.FC<WhatWorkedProps> = ({ byKind, bySize, byAngle, learned, songTitle }) => {
  const intl = useIntl();
  const sentence = learned.sentenceKey === null ? null : LEARNED_SENTENCES[learned.sentenceKey];
  return (
    <section className={card.card} data-testid="what-worked">
      <div>
        <h3 className={card.cardTitle}>{intl.formatMessage(messages.workedTitle)}</h3>
        <p className={card.cardIntro}>{intl.formatMessage(messages.workedIntro)}</p>
      </div>
      <div className={styles.worked}>
        <WorkedGroup title={intl.formatMessage(messages.byKind)} group="kind" rows={byKind} metric="replied" />
        <WorkedGroup title={intl.formatMessage(messages.bySize)} group="size" rows={bySize} metric="added" />
        <WorkedGroup title={intl.formatMessage(messages.byAngle)} group="angle" rows={byAngle} metric="replied" />
      </div>
      {sentence !== null && (
        <div className={styles.learn} data-testid="what-worked-learned">
          <FontAwesomeIcon icon={faSparkles} />
          <b>{intl.formatMessage(sentence, { song: songTitle })}</b>
        </div>
      )}
    </section>
  );
};

export const WhatWorked = TypedMemo(WhatWorkedComponent);
